import apiFetch from '../apiFetch'

export default function (token, { page, pageSize, orderBy, clientNumber, requestAmount, vinChassis, makerNumberRenting, dealerNumber }) {
  const queryParamsArray = [
    page ? `page=${page}` : null,
    pageSize ? `pageSize=${pageSize}` : null,
    orderBy ? `orderBy=${orderBy}` : null,
    clientNumber ? `clientNumber=${clientNumber}` : null,
    requestAmount ? `requestAmount=${requestAmount}` : null,
    vinChassis ? `vinChassis=${vinChassis}` : null,
    makerNumberRenting ? `makerNumberRenting=${makerNumberRenting}` : null,
    dealerNumber ? `dealerNumber=${dealerNumber}` : null
  ]
  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({
    endPoint: `DossierFinder/DossiersRenting${queryParams}`,
    method: 'GET',
    body: null,
    token: token
  })
}
